import { render } from "./CustomSelect.vue?vue&type=template&id=0da7a402"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"

import "./CustomSelect.vue?vue&type=style&index=0&id=0da7a402&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__